import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import Editor from "@tinymce/tinymce-vue";
export default {
  name: "FormContent.vue",
  components: {
    Editor: Editor
  },
  data: function data() {
    return {
      title: "",
      content: "",
      editorApiKey: process.env.VUE_APP_EDITOR_API_KEY
    };
  },
  computed: _objectSpread({}, mapGetters({
    currentProvider: "profile/currentProvider"
  })),
  methods: {
    getData: function getData() {
      return {
        title: this.title,
        content: this.content
      };
    }
  },
  props: {
    titleVisible: {
      type: Boolean,
      required: false
    }
  }
};